export const lineGlobalColors = [
  '#1C1C1C',
  '#2f7cf8',
  '#03c6f7',
  '#ffb600',
  'var(--chart-text-color)',
  'var(--chart-secondary-color)',
  'var(--chart-background-color)',
  'var(--chart-axis-label-color)',
  'var(--chart-grid-line-color)',
];

export const barGlobalColors = [
  '#1C1C1C',
  'var(--chart-bar-blue)',
  'var(--chart-bar-gold)',
  'var(--chart-bar-desert-rose)',
  'var(--chart-text-color)',
  'var(--chart-secondary-color)',
  'var(--chart-background-color)',
  'var(--chart-axis-label-color)',
  'var(--chart-grid-line-color)',
];
